// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__6bwpn","container":"not-found_container__ExcKM","content":"not-found_content__htDlG","link":"not-found_link__PWKPM"};